import styled from "styled-components";

import { Stack } from "@similarweb/ui-components/foundations";

export const StyledZipCodeContainer = styled(Stack)`
    gap: 8px;
`;
